module.exports = __webpack_public_path__ + "img/lg_ring_y_l_1_1@2x.0e4471c2.png";